{
    "Accessibility menu": "Saavutettavuusvalikko",
    "Close": "Sulje",
    "Content adjustments": "Sisällön säädöt",
    "Navigation adjustments": "Navigoinnin säädöt",
    "Text Align": "Text Align",
    "Align Left": "Tasaa vasemmalle",
    "Align Center": "Align Center",
    "Align Right": "Align Right",
    "Adjust Font Size": "Säädä fonttikokoa",
    "Highlight Title": "Korosta otsikko",
    "Highlight Links": "Korosta linkit",
    "Readable Font": "Helposti luettava fontti",
    "Colour adjustments": "Värien säädöt",
    "Dark Contrast": "Tumma kontrasti",
    "Light Contrast": "Vaalea kontrasti",
    "High Contrast": "Korkea kontrasti",
    "High Saturation": "Korkea kylläisyys",
    "Low Saturation": "Matala kylläisyys",
    "Monochrome": "Yksivärinen",
    "Tools": "Työkalut",
    "Reading Guide": "Lukemisopas",
    "Big Cursor": "Iso kohdistin",
    "Increase Font Size": "Suurenna fonttikokoa",
    "Decrease Font Size": "Pienennä fonttikokoa",
    "Letter Spacing": "Kirjainten välistys",
    "Line Height": "Rivin korkeus",
    "Font Weight": "Fontin paksuus",
    "Dyslexia Font": "Dysleksiafontti",
    "Language": "Kieli",
    "Accessibility widget": "Avaa saavutettavuusvalikko",
    "Accessibility Profiles": "Saavutettavuusprofiilit",
    "Cognitive Disability": "Kognitiivinen vamma",
    "Seizure Safe": "Turvallinen epilepsialle",
    "Accessibility statement": "Saavutettavuusseloste",
    "ADHD": "ADHD",
    "Low Vision": "Low Vision",
    "Pause Animations": "Pysäytä animaatiot",
    "Reset all settings": "Palauta asetukset",
    "Shortcut:": "Shortcut:",
    "Epilepsy Safe Mode": "Epilepsy Safe Mode",
    "Mute sounds": "Mute sounds",
    "Page read": "Page read",
    "Page read controls": "Page read controls",
    "Pause": "Pause",
    "Resume": "Resume",
    "Stop": "Stop",
    "Settings": "Settings",
    "Speed": "Speed",
    "Voice": "Voice"
}
